"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e=typeof Deno=="object"&&Deno&&typeof Deno.version=="object";exports.engineIsDeno=e;
